/**
 * Shipped audio files (08 §8, 15 §7): id → Vite asset URL. Only the nine stems ship as
 * files; everything else is live synth. Every id here must also have a `synth` recipe
 * (the audio-synth hygiene test checks) — the file is an upgrade, never a dependency.
 */
import type { SoundId } from './manifest.js'
import stemTick from '../assets/audio/stems/stem_tick.ogg?url'
import stemPulseLow from '../assets/audio/stems/stem_pulse_low.ogg?url'
import stemKit from '../assets/audio/stems/stem_kit.ogg?url'
import stemMetal from '../assets/audio/stems/stem_metal.ogg?url'
import stemLowHits from '../assets/audio/stems/stem_low_hits.ogg?url'
import stemRide from '../assets/audio/stems/stem_ride.ogg?url'
import stemDrone from '../assets/audio/stems/stem_drone.ogg?url'
import stemHub from '../assets/audio/stems/stem_hub.ogg?url'
import stemResults from '../assets/audio/stems/stem_results.ogg?url'

export const SOUND_FILES: Partial<Record<SoundId, string>> = {
  stem_tick: stemTick,
  stem_pulse_low: stemPulseLow,
  stem_kit: stemKit,
  stem_metal: stemMetal,
  stem_low_hits: stemLowHits,
  stem_ride: stemRide,
  stem_drone: stemDrone,
  stem_hub: stemHub,
  stem_results: stemResults,
}
